import React from 'react';

interface IconProps {
	className?: string;
	style?: React.CSSProperties;
}


const GridIcon = (props: IconProps) => {
	return (
		<svg
			fill="none"
			height="20"
			viewBox="0 0 20 20"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.16675 5.83333H15.8334"
				stroke="#2F323E"
				strokeLinecap="round"
			/>
			<path d="M4.16675 10H15.8334" stroke="#2F323E" strokeLinecap="round" />
			<path
				d="M4.16675 14.1667H15.8334"
				stroke="#2F323E"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default GridIcon;
